import React, { useState, useEffect } from 'react';
import { Modal, Tabs, Tab } from 'react-bootstrap';
import ShopItemDetailsForm from './ShopItemDetailsForm';
import ShopItemRewardsForm from './ShopItemRewardsForm';

const EditShopItemModal = ({
  open,
  handleClose,
  shopItem,
  rewards,
  token,
  fetchRewards,
  isVip = false,
  isWaitlist = false,
  shopEnableOnly = false,
  shopReadOnly = false,
  rewardsStatus = 'ready',
  promo,
  shopItems,
  refreshShopItems,
}) => {
  const [activeTab, setActiveTab] = useState('details');
  const [editedShopItem, setEditedShopItem] = useState(shopItem);

  useEffect(() => {
    setEditedShopItem(shopItem);
  }, [shopItem]);

  return (
    <Modal show={open} onHide={handleClose} size="xl">
      <Modal.Body>
        <Tabs id="edit-shop-item-tabs" activeKey={activeTab} onSelect={k => setActiveTab(k)}>
          <Tab eventKey="details" title="Details">
            <ShopItemDetailsForm
              shopItem={editedShopItem}
              onChange={setEditedShopItem}
              token={token}
              handleClose={handleClose}
              isVip={isVip}
              isWaitlist={isWaitlist}
              promo={promo}
              shopItems={shopItems}
              refreshShopItems={refreshShopItems}
              enableOnly={shopEnableOnly}
              readOnly={shopReadOnly}
            />
          </Tab>
          <Tab eventKey="rewards" title="Rewards">
            <ShopItemRewardsForm
              rewards={rewards}
              fetchRewards={fetchRewards}
              promoId={shopItem.promoId}
              itemId={shopItem.itemId}
              token={token}
              handleClose={handleClose}
              isVip={isVip}
              isWaitlist={isWaitlist}
              rewardsStatus={rewardsStatus}
              readOnly={shopEnableOnly || shopReadOnly}
            />
          </Tab>
        </Tabs>
      </Modal.Body>
    </Modal>
  );
};

export default EditShopItemModal;
